import { ResultsState } from 'enums'
import React from 'react'

import { useToggleState } from 'hooks/useToggleState'
import { ExternalRequestTag } from 'modules/requests/components/ExternalRequestTag'
import { EditableAssigneeTag, RequestedByTag, RequestedOnTag, WorkspaceTag } from 'modules/requests/components/RequestMetaTags/RequestMetaTags'
import { isExternalDataAccessRequest } from 'modules/requests/utils'
import AssignToModal from 'modules/resultsV2/AssignToModal'
import ResultStatusTag from 'modules/resultsV2/ResultStatusTag'
import { TagWrapper, TagsWrapper } from 'modules/resultsV2/Results.styles'
import { type Result, ResultRequestType } from 'services/results/types'

interface TagsProps {
  result: Result
}

const getWorkspaceTagName = (result: Result): string | undefined => {
  if (result.requestType === ResultRequestType.DataAccessRequest && result.dataAccessRequest) {
    return result.dataAccessRequest.requesterWorkspaceName
  }

  return result.workspaceName
}

const Tags: React.FC<TagsProps> = ({ result }) => {
  const [isAssignToModalOpen, toggleAssignToModal] = useToggleState(false)
  const workspaceTagName = getWorkspaceTagName(result)

  return (
    <TagsWrapper>
      <TagWrapper>
        <ResultStatusTag status={result?.status} />
      </TagWrapper>
      {isExternalDataAccessRequest(result) && (
        <TagWrapper>
          <ExternalRequestTag />
        </TagWrapper>
      )}
      {!!result?.requestingUser?.email && <RequestedByTag email={result.requestingUser.email} />}
      <RequestedOnTag at={result?.createdAt} />
      {!!workspaceTagName && <WorkspaceTag name={workspaceTagName} />}
      <EditableAssigneeTag
        email={result?.assignedTo?.email}
        isEditable={result?.status === ResultsState.PendingVerification}
        onEdit={toggleAssignToModal}
      />

      <AssignToModal
        resultId={result._id}
        open={isAssignToModalOpen}
        onClose={toggleAssignToModal}
        assignedTo={result?.assignedTo?._id}
      />
    </TagsWrapper>
  )
}

export default Tags
